/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { APP_ENTRYPOINT } from '../../../config/config';
import { request } from '../../request/request';
// import { any } from 'prop-types';

function* getAllFloorsInBuilding(values: any) {
  return yield request.get(
    `${APP_ENTRYPOINT}/floor/getAllFloorsInBuilding`,
    {
      params: {
        buildingId: values,
      },
    },
  );
}
function* getFloorById(values: any) {
  return yield request.get(`${APP_ENTRYPOINT}/admin/getClientFloorById`, {
    params: {
      floorId: values,
    },
  });
}
const department = {
  getAllFloorsInBuilding,
  getFloorById,
};

export default department;
